import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Context from '../../../utils/context';
import LoginEdit from '../../users/login_edit';
import ProfileEdit from '../../users/profile_edit';
import styles from './acc_details.module.css';

export default function ProviderAccountDetails({}) {
  const context = useContext(Context);
  const user = context.auth.getCurrentUser();
  let history = useHistory();

  const isMobile = context.viewport.getIsMobile();

  return (
    <div className={`container-fluid ${styles.roster_container_wrapper}`}>
      <div className={styles.roster_container}>
        <div className='container'>
          <p className='text-link all-surgeons-button text-left marg-bottom-0'>
            <a onClick={() => history.goBack()} data-gtm-click-label={`No Procedure Results Back`}>
              Back
            </a>
          </p>
          <div className='row'>
            <div className='col'>
              <div className={`${styles.profile_photo_name_wrap} h-100 marg-bottom-50`}>
                <div className={`${styles.profile_photo} my-auto`} style={{ backgroundImage: `url(${user.photo})` }} />
                <p className={`my-auto`}>{user.name}</p>
              </div>
            </div>
          </div>
          <div className={`row ${styles.roster_row}`}>
            <div className={`col-md-6 ${isMobile ? 'marg-bottom-50' : ''}`}>
              <div className={styles.roster_container}>
                <ProfileEdit />
              </div>
            </div>
            <div className={`col-md-6 ${isMobile ? 'marg-bottom-50' : ''}`}>
              <div className={styles.roster_container}>
                <LoginEdit />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
